module.exports = {
          srcSet: __webpack_public_path__ + "public/0dad05a3949f8f150d7765633d946056-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/0dad05a3949f8f150d7765633d946056-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/0dad05a3949f8f150d7765633d946056-80.png",
          toString:function(){return __webpack_public_path__ + "public/0dad05a3949f8f150d7765633d946056-80.png"},
          
          width: 80,
          height: 80
        }